// @ts-nocheck

(() => {
  function initSettingsOverlay() {
    const trigger = document.querySelector('[data-settings-trigger]');
    const overlay = document.querySelector('.settings-overlay');

    if (!trigger || !overlay) return;

    const triggerEl = trigger;
    const overlayEl = overlay;

    if (overlayEl.parentElement !== document.body) {
      document.body.appendChild(overlayEl);
    }

    const panel = overlayEl.querySelector('.settings-panel');
    const PANEL_GAP = 12;
    const VIEWPORT_MARGIN = 12;
    const OPEN_CLASS = 'is-open';
    const CLOSE_DURATION_MS = 180;
    let closeTimer = 0;

    function positionPanel() {
      if (!panel || overlayEl.hidden) return;

      const triggerRect = triggerEl.getBoundingClientRect();
      const panelRect = panel.getBoundingClientRect();

      let left = triggerRect.left;
      left = Math.max(VIEWPORT_MARGIN, Math.min(window.innerWidth - panelRect.width - VIEWPORT_MARGIN, left));

      let top = triggerRect.top - panelRect.height - PANEL_GAP;
      if (top < VIEWPORT_MARGIN) {
        top = Math.min(window.innerHeight - panelRect.height - VIEWPORT_MARGIN, triggerRect.bottom + PANEL_GAP);
      }

      panel.style.left = `${Math.round(left)}px`;
      panel.style.top = `${Math.round(top)}px`;
    }

    function open() {
      window.clearTimeout(closeTimer);
      overlayEl.hidden = false;
      overlayEl.classList.remove(OPEN_CLASS);
      document.documentElement.classList.add('settings-open');

      requestAnimationFrame(() => {
        positionPanel();
        overlayEl.classList.add(OPEN_CLASS);
        syncSegmentThumbs();
      });
    }

    function close() {
      overlayEl.classList.remove(OPEN_CLASS);
      document.documentElement.classList.remove('settings-open');

      closeTimer = window.setTimeout(() => {
        overlayEl.hidden = true;
      }, CLOSE_DURATION_MS);
    }

    triggerEl.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });

    overlayEl.addEventListener('click', (e) => {
      const target = e.target;
      if (!(target instanceof Node)) return;
      if (!panel || !panel.contains(target)) close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlayEl.hidden) close();
    });

    window.addEventListener('resize', positionPanel);
    window.addEventListener('scroll', positionPanel, true);

    const syncSegmentThumbs = setupSegments(overlayEl);
    requestAnimationFrame(() => {
      syncSegmentThumbs();
    });
  }

  function setupSegments(root) {
    const syncers = [];

    root.querySelectorAll('.settings-group[data-segment]').forEach((segEl) => {
      const seg = segEl;
      const thumb = seg.querySelector('.settings-thumb');
      const buttons = Array.from(seg.querySelectorAll('.settings-option'));

      if (!thumb || buttons.length < 2) return;

      const thumbEl = thumb;

      function getInitialActiveIndex() {
        const classBasedIndex = Math.max(0, buttons.findIndex((b) => b.classList.contains('is-active')));

        if (!seg.hasAttribute('data-units')) return classBasedIndex;

        try {
          const storedUnit = (localStorage.getItem('novu_unit') || '').toLowerCase();
          if (!storedUnit) return classBasedIndex;
          const storedIndex = buttons.findIndex((b) => (b.dataset.unit || '').toLowerCase() === storedUnit);
          return storedIndex >= 0 ? storedIndex : classBasedIndex;
        } catch (_err) {
          return classBasedIndex;
        }
      }

      let activeIndex = getInitialActiveIndex();
      let dragging = false;
      let draggedRecently = false;
      let startX = 0;
      let startTranslate = 0;
      const GAP = 0;
      const PADDING = 0;

      function calcSizes() {
        const rect = seg.getBoundingClientRect();
        const innerW = rect.width - PADDING * 2;
        const btnW = (innerW - GAP * (buttons.length - 1)) / buttons.length;
        return { btnW };
      }

      function setActive(index, animate = true) {
        index = Math.max(0, Math.min(buttons.length - 1, index));
        buttons.forEach(b => b.classList.remove('is-active'));
        const activeButton = buttons[index];
        if (!activeButton) return;
        activeButton.classList.add('is-active');
        activeIndex = index;

        thumbEl.style.transition = animate ? 'transform 220ms cubic-bezier(.2,.8,.2,1)' : 'none';
        const { btnW } = calcSizes();
        const x = activeIndex * (btnW + GAP);
        thumbEl.style.width = `${btnW}px`;
        thumbEl.style.transform = `translateX(${x}px)`;
      }

      function syncThumb() { setActive(activeIndex, false); }
      syncers.push(syncThumb);

      seg.addEventListener('click', (e) => {
        if (draggedRecently) return;
        const rect = seg.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const idx = Math.floor((x / rect.width) * buttons.length);
        setActive(idx, true);
      });

      seg.addEventListener('pointerdown', (e) => {
        draggedRecently = false;
        dragging = true;
        startX = e.clientX;
        const matrix = new DOMMatrixReadOnly(getComputedStyle(thumbEl).transform);
        startTranslate = matrix.m41 || 0;
        thumbEl.style.transition = 'none';
        seg.setPointerCapture?.(e.pointerId);
      });

      seg.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 6) draggedRecently = true;
        const { btnW } = calcSizes();
        let next = startTranslate + dx;
        next = Math.max(0, Math.min((buttons.length - 1) * (btnW + GAP), next));
        thumbEl.style.transform = `translateX(${next}px)`;
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        const { btnW } = calcSizes();
        const matrix = new DOMMatrixReadOnly(getComputedStyle(thumbEl).transform);
        const x = matrix.m41 || 0;
        const idx = Math.round(x / (btnW + GAP));
        setActive(idx, true);
        setTimeout(() => { draggedRecently = false; }, 0);
      }

      seg.addEventListener('pointerup', endDrag);
      seg.addEventListener('pointercancel', endDrag);
      syncThumb();
      window.addEventListener('resize', syncThumb);
    });

    return () => { syncers.forEach((sync) => sync()); };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSettingsOverlay);
  } else {
    initSettingsOverlay();
  }
})();

(() => {
  const roots = document.querySelectorAll('[data-announcement-settings]');
  if (!roots.length) return;

  function setupSegments(segmentRoot) {
    const syncers = [];

    segmentRoot.querySelectorAll('[data-segment]').forEach((segEl) => {
      const seg = segEl;
      const thumb = seg.querySelector('.announcement-settings-thumb');
      const buttons = Array.from(seg.querySelectorAll('.announcement-settings-option'));

      if (!thumb || buttons.length < 2) return;

      let activeIndex = Math.max(0, buttons.findIndex((button) => button.classList.contains('is-active')));
      let dragging = false;
      let draggedRecently = false;
      let startX = 0;
      let startTranslate = 0;

      if (seg.hasAttribute('data-units')) {
        try {
          const storedUnit = (localStorage.getItem('novu_unit') || '').toLowerCase();
          const storedIndex = buttons.findIndex((button) => (button.dataset.unit || '').toLowerCase() === storedUnit);
          if (storedIndex >= 0) activeIndex = storedIndex;
        } catch (_error) {}
      }

      function getSegmentMetrics() {
        const styles = getComputedStyle(seg);
        const gap = Number.parseFloat(styles.getPropertyValue('--segment-gap')) || 0;
        const padding = Number.parseFloat(styles.getPropertyValue('--segment-padding')) || 0;
        return { gap, padding };
      }

      function calcSizes() {
        const { gap, padding } = getSegmentMetrics();
        const rect = seg.getBoundingClientRect();
        const innerWidth = rect.width - padding * 2;
        const buttonWidth = (innerWidth - gap * (buttons.length - 1)) / buttons.length;
        return { buttonWidth, gap };
      }

      function setActive(index, animate = true) {
        const clampedIndex = Math.max(0, Math.min(buttons.length - 1, index));
        buttons.forEach((button) => button.classList.remove('is-active'));
        const activeButton = buttons[clampedIndex];
        if (!activeButton) return;
        activeButton.classList.add('is-active');
        activeIndex = clampedIndex;
        thumb.style.transition = animate ? 'transform 220ms cubic-bezier(.2,.8,.2,1)' : 'none';
        const { buttonWidth, gap } = calcSizes();
        const x = activeIndex * (buttonWidth + gap);
        thumb.style.width = `${buttonWidth}px`;
        thumb.style.transform = `translateX(${x}px)`;
      }

      function syncThumb() { setActive(activeIndex, false); }
      syncers.push(syncThumb);

      seg.addEventListener('click', (event) => {
        if (draggedRecently) return;
        const rect = seg.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const index = Math.floor((x / rect.width) * buttons.length);
        setActive(index, true);
      });

      seg.addEventListener('pointerdown', (event) => {
        draggedRecently = false;
        dragging = true;
        startX = event.clientX;
        const matrix = new DOMMatrixReadOnly(getComputedStyle(thumb).transform);
        startTranslate = matrix.m41 || 0;
        thumb.style.transition = 'none';
        seg.setPointerCapture?.(event.pointerId);
      });

      seg.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const dx = event.clientX - startX;
        if (Math.abs(dx) > 6) draggedRecently = true;
        const { buttonWidth, gap } = calcSizes();
        const maxX = (buttons.length - 1) * (buttonWidth + gap);
        let next = startTranslate + dx;
        next = Math.max(0, Math.min(maxX, next));
        thumb.style.transform = `translateX(${next}px)`;
      });

      function endDrag() {
        if (!dragging) return;
        dragging = false;
        const { buttonWidth, gap } = calcSizes();
        const matrix = new DOMMatrixReadOnly(getComputedStyle(thumb).transform);
        const x = matrix.m41 || 0;
        const index = Math.round(x / (buttonWidth + gap));
        setActive(index, true);
        window.setTimeout(() => { draggedRecently = false; }, 0);
      }

      seg.addEventListener('pointerup', endDrag);
      seg.addEventListener('pointercancel', endDrag);
      syncThumb();
      window.addEventListener('resize', syncThumb);
    });

    return () => { syncers.forEach((sync) => sync()); };
  }

  roots.forEach((root) => {
    const storeGroup = root.querySelector('[data-segment-type="store"]');
    if (!storeGroup) return;

    const languageGroup = root.querySelector('[data-language]');
    const unitsGroup = root.querySelector('[data-units]');
    const saveBtn = root.querySelector('.announcement-settings-save');
    const defaultLanguage = (root.dataset.defaultLanguage || 'en').toLowerCase();

    const syncSegmentThumbs = setupSegments(root);
    window.requestAnimationFrame(syncSegmentThumbs);
    document.addEventListener('announcement-bar:shown', () => {
      window.requestAnimationFrame(syncSegmentThumbs);
    });

    function getSelectedStore() {
      const selected = storeGroup.querySelector('.announcement-settings-option.is-active');
      return selected?.dataset.value || 'paris';
    }

    function getSelectedLanguage() {
      const selected = languageGroup?.querySelector('.announcement-settings-option.is-active') || null;
      return selected?.dataset.lang || defaultLanguage;
    }

    function getSelectedUnit() {
      const selected = unitsGroup?.querySelector('.announcement-settings-option.is-active') || null;
      return selected?.dataset.unit || 'cm';
    }

    function isFrenchLanguage(langCode) {
      return langCode.toLowerCase().startsWith('fr');
    }

    function isBlockedSelection(store, langCode) {
      return store === 'nyc' && isFrenchLanguage(langCode);
    }

    function updateSaveButtonState() {
      if (!saveBtn) return;
      const blocked = isBlockedSelection(getSelectedStore(), getSelectedLanguage());
      saveBtn.disabled = blocked;
      saveBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    }

    function savePreferences() {
      const selectedStore = getSelectedStore();
      const selectedLanguage = getSelectedLanguage();
      const selectedUnit = getSelectedUnit();

      if (isBlockedSelection(selectedStore, selectedLanguage)) return;

      document.dispatchEvent(new CustomEvent('announcement-bar:save'));

      try { localStorage.setItem('novu_segment', selectedStore); } catch (_error) {}
      try { localStorage.setItem('novu_language', selectedLanguage); } catch (_error) {}
      try { localStorage.setItem('novu_unit', selectedUnit); } catch (_error) {}

      if (selectedStore === 'nyc') {
        window.open('https://novu.nyc/', '_blank', 'noopener,noreferrer');
      } else {
        if (isFrenchLanguage(selectedLanguage)) {
          window.location.href = 'https://novu.fr/fr';
        } else {
          window.location.href = 'https://novu.fr';
        }
      }
    }

    function scheduleSaveButtonStateUpdate() {
      window.setTimeout(updateSaveButtonState, 0);
    }

    if (saveBtn) {
      saveBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (saveBtn.disabled) return;
        savePreferences();
      });
    }

    updateSaveButtonState();

    storeGroup.addEventListener('click', scheduleSaveButtonStateUpdate);
    storeGroup.addEventListener('pointerup', scheduleSaveButtonStateUpdate);

    if (languageGroup) {
      languageGroup.addEventListener('click', scheduleSaveButtonStateUpdate);
      languageGroup.addEventListener('pointerup', scheduleSaveButtonStateUpdate);
    }

    const titleToggle = document.querySelector('[data-announcement-title-toggle]');
    if (titleToggle) {
      titleToggle.setAttribute('role', 'button');
      titleToggle.setAttribute('tabindex', '0');
      titleToggle.setAttribute('aria-expanded', 'false');

      titleToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const isOpen = root.classList.toggle('is-open');
        titleToggle.classList.toggle('is-open', isOpen);
        titleToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) window.requestAnimationFrame(syncSegmentThumbs);
      });

      document.addEventListener('click', (event) => {
        const bar = document.querySelector('.announcement-bar');
        if (!bar || !bar.contains(event.target)) {
          root.classList.remove('is-open');
          titleToggle.classList.remove('is-open');
          titleToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
})();

(() => {
  const COOKIE_NAME = 'announcement_bar_closed';
  const COOKIE_DURATION_DAYS = 30;

  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
  }

  function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(nameEQ)) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }
    return null;
  }

  function showAnnouncementBar() {
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      announcementBar.classList.add('is-visible');
      document.dispatchEvent(new CustomEvent('announcement-bar:shown'));
    }
  }

  function hideAnnouncementBar() {
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      announcementBar.classList.remove('is-visible');
    }
  }

  function initCloseButton() {
    const closeBtn = document.querySelector('.announcement-bar__close');
    if (!closeBtn) return;

    closeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setCookie(COOKIE_NAME, 'true', COOKIE_DURATION_DAYS);
      hideAnnouncementBar();
    });
  }

  function initFormSaveClose() {
    document.addEventListener('announcement-bar:save', () => {
      setCookie(COOKIE_NAME, 'true', COOKIE_DURATION_DAYS);
      hideAnnouncementBar();
    });
  }

  function initMobileScrollHide() {
    const announcementBar = document.querySelector('.announcement-bar');
    if (!announcementBar) return;

    const mobileMedia = window.matchMedia('(max-width: 989px)');
    let ticking = false;

    function updateVisibilityOnScroll() {
      ticking = false;
      if (!mobileMedia.matches) {
        announcementBar.classList.remove('is-scrolled-hidden');
        return;
      }
      const shouldHide = window.scrollY > 100;
      announcementBar.classList.toggle('is-scrolled-hidden', shouldHide);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibilityOnScroll);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', requestUpdate);
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(requestUpdate);
    }

    requestUpdate();
  }

  function initAnnouncementBar() {
    const isClosed = getCookie(COOKIE_NAME);
    if (isClosed !== 'true') {
      showAnnouncementBar();
      initCloseButton();
      initFormSaveClose();
      initMobileScrollHide();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementBar);
  } else {
    initAnnouncementBar();
  }
})();